export default __webpack_public_path__ + "static/media/assignment.b80553b0.svg";